import React from 'react'
import Link from 'gatsby-link'

import './style.scss'

const Button = ({ primary, secondary, full, text, link }) => {
  const buttonClasses = [
    'btn',
    secondary && 'btn--secondary',
    full && 'btn--full'
  ].join(' ')

  return (
    <Link className={buttonClasses} to={link}>{text}</Link>
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/buttons/index.js